import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertDialogComponent } from '@sb-shared/components/alert-dialog/alert-dialog.component';
import { PleaseWaitModalComponent } from '@sb-shared/components/please-wait-modal/please-wait-modal.component';
import { UiClasses } from '@sb-shared/types/ui-classes';

export interface SimpleAlertOptions {
  title?: string;
  message?: string;
  messageArray?: string[];
  translateMessage?: boolean;
  messageTranslationParameters?: any;
  windowSize?: 'sm' | 'md' | 'lg' | 'xl';
  headerClass?: UiClasses;
  iconClass?: string;
  okButtonText?: string;
  okButtonClass?: UiClasses;
  cancelButtonText?: string;
  animate?: boolean;
  staticBackdrop?: boolean;
}

export interface SimpleAlertInstance {
  result: Promise<any>;
}

@Injectable({
  providedIn: 'root'
})
export class SimpleAlertService {

  constructor(private modalService: NgbModal) {}

  simpleAlert(options: SimpleAlertOptions = {}): SimpleAlertInstance {
    const resolved: SimpleAlertOptions = {
      title: '',
      message: '',
      translateMessage: true,
      windowSize: 'md',
      okButtonText: 'SB_OK',
      // Legacy confirmation-popup always rendered the OK/Confirm button green (btn-success).
      okButtonClass: 'success',
      cancelButtonText: '',
      animate: true,
      staticBackdrop: false,
      ...options
    };

    const modalRef: NgbModalRef = this.modalService.open(AlertDialogComponent, {
      size: resolved.windowSize,
      backdrop: resolved.staticBackdrop ? 'static' : true,
      animation: resolved.animate !== false
    });

    const instance = modalRef.componentInstance as AlertDialogComponent;
    instance.title = resolved.title;
    instance.message = resolved.message;
    instance.messageArray = resolved.messageArray || [];
    instance.translateMessage = resolved.translateMessage !== false;
    instance.messageTranslationParameters = resolved.messageTranslationParameters;
    instance.headerClass = resolved.headerClass || '';
    instance.iconClass = resolved.iconClass || '';
    instance.okButtonText = resolved.okButtonText;
    instance.okButtonClass = resolved.okButtonClass || 'success';
    instance.cancelButtonText = resolved.cancelButtonText;

    return { result: modalRef.result };
  }

  errorAlert(options: SimpleAlertOptions = {}): SimpleAlertInstance {
    return this.simpleAlert({
      title: 'SB_Error',
      message: 'SB_Error_Generic',
      iconClass: 'fas fa-exclamation-triangle',
      ...options
    });
  }

  successAlert(options: SimpleAlertOptions = {}): SimpleAlertInstance {
    return this.simpleAlert({
      title: 'SB_Success',
      iconClass: 'fas fa-check',
      ...options
    });
  }

  pleaseWaitModal(options: { windowSize?: 'sm' | 'md' | 'lg' | 'xl'; message?: string } = {}): NgbModalRef {
    const modalRef: NgbModalRef = this.modalService.open(PleaseWaitModalComponent, {
      size: options.windowSize || 'sm',
      backdrop: 'static',
      keyboard: false,
      centered: true
    });
    if (options.message) {
      (modalRef.componentInstance as PleaseWaitModalComponent).message = options.message;
    }
    return modalRef;
  }
}
